import React from 'react';
import FileContent from '../../components/FileContent';
import terms from '../../terms/TCI.Terms.of.Use.docx';

const TermsOfService = () => (
    <FileContent filePath={terms}/>
);

export default TermsOfService;
